import React from 'react';
import Modal, { ModalFooter } from '@amzn/meridian/modal';
import Button from '@amzn/meridian/button';
import Alert from '@amzn/meridian/alert';
import Row from '@amzn/meridian/row';

export const DEFAULT_CONSENT_TITLE = 'Continue without consent';

export const DEFAULT_CONSENT_MESSAGE =
  "Without associate consent, conversation transcripts won't be recorded. " +
  'You can still add your own notes and generate summary. Would you like to continue?';

const MODAL_WIDTH = 480;
const CONTINUE_LABEL = 'Continue without consent';

export interface ConsentConfirmationModalProps {
  open: boolean;
  onConfirmDecline: () => void;
  title?: string;
  message?: string;
}

const ConsentConfirmationModal: React.FC<ConsentConfirmationModalProps> = ({
  open,
  onConfirmDecline,
  title = DEFAULT_CONSENT_TITLE,
  message = DEFAULT_CONSENT_MESSAGE,
}) => (
  <Modal
    title={title}
    open={open}
    width={MODAL_WIDTH}
    scrollContainer="viewport"
    aria-describedby="consent-confirmation-message"
  >
    <Alert id="consent-confirmation-message" type="warning" size="medium">
      {message}
    </Alert>
    <ModalFooter>
      <Row alignmentHorizontal="end" widths="fit">
        <Button type="primary" size="small" onClick={onConfirmDecline}>
          {CONTINUE_LABEL}
        </Button>
      </Row>
    </ModalFooter>
  </Modal>
);

export default ConsentConfirmationModal;
